<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="fnSimpleAttribution.attributionMarche"
	[label]="step4.getattributionMarche" [type]="'text'" [rule]="'minSize_5|maxSize_32768|required'"
	[errorMessage]="{'required' : 'ctr_9801'}" [name]="getUid() + '_SepAtt_attributionMarche'">
</app-form-input>
